import AsyncState, { createAsyncStateReducer } from "react-async-stateful";

import * as ReduxUtils from "../../lib/util/ReduxUtils";

import * as NavigationUtils from "../../lib/util/NavigationUtils";

import * as InsightsActions from "./Insights.action";
import * as InsightsSelectors from "./Insights.selector";
import { Insight } from "../../lib/types/InsightTypes";

export interface InsightReducerState {
	insights: AsyncState<Insight[]>;
	navigationSelection: string;
	filterSelection: {
		category: string;
	};
}

const initialState: InsightReducerState = {
	insights: AsyncState.create([]),
	navigationSelection: "all",
	filterSelection: {
		category: "all",
	},
};

export default ReduxUtils.composeReducer(initialState, [
	createAsyncStateReducer<InsightReducerState>({
		insights: InsightsActions.getInsights.type,
	}),

	ReduxUtils.createReducerMap({
		[InsightsActions.resetSelections.type]: (state, action) => ({
			...state,
			navigationSelection:
				InsightsSelectors.selectRouteFromHash(NavigationUtils.getHash())?.id ||
				"all",
			filterSelection: initialState.filterSelection,
		}),

		[InsightsActions.setNavigationSelection.type]: (state, action) => {
			return { ...state, navigationSelection: action.payload };
		},
		[InsightsActions.setFilterSelection.type]: (state, action) => {
			return {
				...state,
				filterSelection: Object.assign({}, state.filterSelection, {
					[action.payload.filterType]: action.payload.value,
				}),
			};
		},
	}),
]);
